import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchSegmentEntity } from '../../domain/entities/BranchSegmentEntity'

export class UpdateBranchSegmentModel extends BranchSegmentEntity {
  constructor(dataDto: BranchSegmentEntity) {
    super()
    mapEntityProperties<UpdateBranchSegmentModel>(this, dataDto, {
      map: {
        from: dataDto.from === 0 ? 0 : dataDto.from ? dataDto.from * 1000 : undefined,
        to: dataDto.to === 0 ? 0 : dataDto.to ? dataDto.to * 1000 : undefined
      }
    })
  }
}
